import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableCell as MuiTableCell
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const TableCell = styled(MuiTableCell)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  color: "var(--primary-text)",
  borderColor: "var(--border)",
  ...styles
}));

export const Table = styled(MuiTable)(({ styles }) => ({
  backgroundColor: "transparent",
  borderColor: "var(--border)",
  ...styles
}));

export const TableBody = styled(MuiTableBody)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  borderColor: "var(--border)",
  ...styles
}));

export const TableContainer = styled(MuiTableContainer)(({ styles }) => ({
  backgroundColor: "var(--container-light)",
  borderColor: "var(--border)",
  borderRadius: "8px",
  ...styles
}));

export const TableHead = styled(MuiTableHead)(({ styles }) => ({
  borderTop: "2px solid var(--border)",
  backgroundColor: "var(--container-light)",
  whiteSpace: "nowrap",
  ...styles
}));
